var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Vector",
    cx: 10,
    cy: 10,
    r: 5,
    fill: "url(#paint0_linear_22_11950)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_11950",
    x1: 5,
    y1: 10,
    x2: 15,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECEE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCircleIcon);
export default __webpack_public_path__ + "static/media/grey-circle-icon.68e535ab0b23ef7a492f7d1417265573.svg";
export { ForwardRef as ReactComponent };